// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__ifDoj","productName":"Table_productName__1tene"};